import { render } from "./typeWorkList.vue?vue&type=template&id=24c47c66&scoped=true&ts=true"
import script from "./typeWorkList.vue?vue&type=script&lang=ts"
export * from "./typeWorkList.vue?vue&type=script&lang=ts"

import "./typeWorkList.vue?vue&type=style&index=0&id=24c47c66&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c47c66"]])

export default __exports__